/* eslint vars-on-top: 0 */
import { MeRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Cookie from 'common/services/util/-RFC.Cookie';


const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$state', '$timeout', '$window',
    'MyAccountCountriesService', 'UserRestService', 'Util', 'MyAccountStatesService', '$rootScope'];

/**
 * @ngdoc directive
 * @name directives.controller.ProfileDetailsController
 *
 * @description
 * edit form for user details controller
 */
class ProfileDetailsController {

    /**
     * @param  {any} $scope
     * @param  {any} $state
     * @param  {any} $timeout
     * @param  {any} $window
     * @param  {any} MyAccountCountriesService
     * @param  {any} UserRestService
     * @param  {any} Util
     * @param  {any} MyAccountStatesService
     */
    constructor(
        $scope, $state, $timeout, $window,
        MyAccountCountriesService, UserRestService, Util,
        MyAccountStatesService, $rootScope,
    ) {

        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$window = $window;
        this.MeRepository = MeRepository;
        this.UserRestService = UserRestService;
        this.MyAccountCountriesService = MyAccountCountriesService;
        this.MyAccountStatesService = MyAccountStatesService;
        this.Util = Util;
        this.user = MeRepository.getMyUser();
        this.$scope.countries = MyAccountCountriesService.getCountries();
        this.$scope.states = MyAccountStatesService.getStates();
        this.$scope.userEmail = this.user.attributes.email;
        this.$scope.userFirstName = this.user.attributes.first_name;
        this.$scope.userLastName = this.user.attributes.last_name;
        this.$scope.billingAddress = this.user.attributes.address;
        this.$scope.city = this.user.attributes.city;
        this.$scope.zipcode = this.user.attributes.zip;
        this.$scope.userFirstNameRegExp = this.Util.getFullNameValidationRegExp();
        this.$scope.userLastNameRegExp = this.Util.getFullNameValidationRegExp();
        this.$scope.billingAddressRegExp = this.Util.getGenericInputValidationRegExp();
        this.$scope.cityRegExp = this.Util.getGenericInputValidationRegExp();
        this.$scope.userLanguage = {};
        this.$scope.userCountry = {};
        this.$scope.userState = {};
        this.$scope.languages = [];
        this.$scope.submitted = false;
        this.$scope.isValidNumber = true;
        this.$scope.phoneInputError = false;
        this.$scope.zipcodeRegexPattern = new RegExp('^([\u00C0-\u017F a-z0-9]{0,})$', 'i');
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
        this.$rootScope = $rootScope;

        // init phone number on selectedDevice object
        this.$scope.selectedDevice = this.$scope.selectedDevice ||
            { phoneNumber: this.user.attributes.phone };

        // default user details (ex: phone, city, zip etc.)
        this.$scope.userDetails = this.user.attributes;

        // facebook, google, or password
        const userLoginType = Cookie.get(CWCONFIG.cookie.loginType);

        // allow user to change his email if he is logged in with email and password account
        this.$scope.canChangeEmail = !userLoginType || userLoginType === 'password';

        angular.forEach(CWCONFIG.languages, (value, key) => {

            this.$scope.languages.push({ code: key, name: value });

        });

        this.$scope.userLanguage.selectedValue = this.$scope.languages.find(value =>
            value.code === this.user.attributes.language);

        this.$scope.userCountry.selectedValue = this.$scope.countries.find(value =>
            value.code === this.user.attributes.country);

        this.$scope.userState.selectedValue = this.$scope.states.find(value =>
            value.code === this.user.attributes.land);

        // MeRepository Observable
        const meRepositoryObservable = MeRepository.getObservable();
        const onNextMeRepository = () => {

            // update form inputs
            this.updateForm();

        };

        // trigger onNextMeRepository() on MeRepository update
        this.meRepositorySubscriber = meRepositoryObservable.subscribe(
            onNextMeRepository,
            () => { },
            () => { },
        );

    }

    /**
     * @ngdoc directive
     * @name directives.controller.ProfileDetailsController#getPhoneNumber
     * @methodOf directives.controller.ProfileDetailsController
     *
     * @description
     * get phone number
     */
    getPhoneNumber() {

        let phoneNumber = this.user.attributes.phone || null;

        if (this.$scope.selectedDevice.country) {

            phoneNumber = `${this.$scope.selectedDevice.country.dialCode}${this.$scope.selectedDevice.phoneNumber}`;

        }

        return phoneNumber || null;

    }

    /**
     * @ngdoc directive
     * @name directives.controller.ProfileDetailsController#method
     * @methodOf directives.controller.ProfileDetailsController
     *
     * @description
     * change user first name, last name, country and - or language
     */
    changeProfileDetails() {

        // set the submitted flag for input errors to be shown when user tries to submit
        this.$scope.submitted = true;

        // reset the value of the validtions happening on the server
        this.$scope.profileDetailsForm.userFirstName.$setValidity('serverValidation', true);
        this.$scope.profileDetailsForm.userLastName.$setValidity('serverValidation', true);
        this.$scope.profileDetailsForm.billingAddress.$setValidity('serverValidation', true);
        this.$scope.profileDetailsForm.city.$setValidity('serverValidation', true);
        this.$scope.profileDetailsForm.zipcode.$setValidity('serverValidation', true);

        // exit the function early if the form is $invalid
        if (this.$scope.profileDetailsForm.$invalid) {

            this.Util.triggerAnimation('.error', 'animated shake');
            return;

        }

        const countryCode = this.$scope.selectedDevice.country ?
            this.$scope.selectedDevice.country.code.substring(0, 2) : '';

        // delete number if the phone input is empty
        if (this.$scope.selectedDevice.phoneNumber === '') {

            this.$scope.isValidNumber = true;

        } else {

            // Check if the phone number is from international calling zone 1 and add to phoneNumber
            const isZoneOne = this.$scope.selectedDevice.country.dialCode.indexOf('+1 ') > -1;
            const phoneNumberZoneOne = isZoneOne ?
                this.$scope.selectedDevice.country.dialCode.substring(3).concat(this.$scope.selectedDevice.phoneNumber) : '';

            this.$scope.isValidNumber = isZoneOne ?
                this.Util.isValidPhoneNumber(phoneNumberZoneOne, countryCode) :
                this.Util.isValidPhoneNumber(this.$scope.selectedDevice.phoneNumber, countryCode);

        }

        const userLanguageChanged =
            this.$scope.userLanguage.selectedValue.code !== this.user.attributes.language;

        // data to be send
        const payload = {
            data: {
                id: this.user.id,
                attributes: {
                    first_name: this.$scope.userFirstName ? this.$scope.userFirstName : null,
                    last_name: this.$scope.userLastName ? this.$scope.userLastName : null,
                    address: this.$scope.billingAddress ? this.$scope.billingAddress : null,
                    country: this.$scope.userCountry.selectedValue.code,
                    land: (this.$scope.userState.selectedValue && this.$scope.userCountry.selectedValue.code === 'US') ?
                        this.$scope.userState.selectedValue.code : null,
                    city: this.$scope.city ? this.$scope.city : null,
                    zip: this.$scope.zipcode ? this.$scope.zipcode : null,
                    language: this.$scope.userLanguage.selectedValue.code,
                },
                relationships: {
                    provider: {
                        data: {
                            type: this.user.relationships.partner.data.type,
                            id: this.user.relationships.partner.data.id,
                        },
                    },
                },
                type: this.user.type,
            },
        };

        // user has a phone number
        if (this.user.attributes.phone) {

            if (this.$scope.isValidNumber) {

                this.$scope.phoneInputError = false;

                // delete number if the phone input is empty
                if (this.$scope.selectedDevice.phoneNumber === '') {

                    angular.extend(payload.data.attributes, { phone: '' });

                } else {

                    // phone number must be part of the payload only if a phone number exists,
                    // else backend phone validation returns an error
                    angular.extend(payload.data.attributes, { phone: this.getPhoneNumber() });

                }

            } else {

                this.$scope.phoneInputError = true;
                this.Util.triggerAnimation('.error', 'animated shake');
                return;

            }

        }

        if (this.$scope.profileDetailsForm.$dirty) {

            // send the payload with the PUT update user method
            this.UserRestService.update(this.user.id, payload).then((response) => {

                this.$scope.submitted = false;
                this.$scope.profileDetailsForm.$setPristine();

                // update the user repository
                this.MeRepository.update(response.data.data);

                // update form with the latest user data from repository
                this.updateForm();

                Mixpanel.send('ConnectWeb Edit Account Click');
                Alert.success('cw.account.details.messages.success');

                // update user info in local storage
                this.Util.updateLastLoginObjectInLocalStorage(response.data.data);

                // set locale for moment js in order to show the correct date format
                if (this.user.attributes.language === 'en') {

                    const currentLocale = moment.locale();

                    if (this.user.attributes.country !== 'US' && currentLocale !== 'en-gb') {

                        moment.locale('en-gb');

                    } else if (this.user.attributes.country === 'US' && currentLocale !== 'en') {

                        moment.locale('en');

                    }

                }

                if (this.$rootScope.accountCountry !== this.user.attributes.country) {

                    this.$window.location.reload();

                }

                // refresh the page on language change
                if (userLanguageChanged) {

                    this.$timeout(() => {

                        this.$window.location.pathname =
                            this.$window.location.pathname.replace(
                                CWCONFIG.language,
                                response.data.data.attributes.language,
                            );

                    }, 100);

                    Mixpanel.send('ConnectWeb ChangeLanguage Success', {
                        Language: response.data.data.attributes.language,
                        'Old Language': CWCONFIG.language,
                    });

                }

            }).then(null, (error) => {

                const errorCode =
                    (error.data.errors && error.data.errors[0]) ? error.data.errors[0].code : false;

                switch (errorCode) {

                // if illegal characters have been used
                // in the first name we give out a more specific error
                case '21109':
                    this.$scope.profileDetailsForm.userFirstName.$setPristine();
                    this.$scope.profileDetailsForm.userFirstName.$setValidity('serverValidation', false);
                    break;

                case '21110':
                    this.$scope.profileDetailsForm.userLastName.$setPristine();
                    this.$scope.profileDetailsForm.userLastName.$setValidity('serverValidation', false);
                    break;

                case '21153':
                    this.$scope.profileDetailsForm.city.$setPristine();
                    this.$scope.profileDetailsForm.city.$setValidity('serverValidation', false);
                    break;

                case '21154':
                    this.$scope.profileDetailsForm.billingAddress.$setPristine();
                    this.$scope.profileDetailsForm.billingAddress.$setValidity('serverValidation', false);
                    break;

                case '21155':
                    this.$scope.profileDetailsForm.zipcode.$setPristine();
                    this.$scope.profileDetailsForm.zipcode.$setValidity('serverValidation', false);
                    break;

                case '1003':
                    this.$scope.phoneInputError = true;
                    this.$scope.isValidNumber = false;
                    break;

                default:
                    Alert.error('cw.account.details.messages.error');
                    break;

                }
                // without a timeout it doesn't find the classes added by ng-class
                this.Util.triggerAnimation('.error', 'animated shake');

            });

        }

    }

    /**
     * @ngdoc directive
     * @name directives.controller.ProfileDetailsController#method
     * @methodOf directives.controller.ProfileDetailsController
     *
     * @description
     * update form with the user details from MeRepository
    */
    updateForm() {

        this.user = this.MeRepository.getMyUser();

        this.$scope.userFirstName = this.user.attributes.first_name;
        this.$scope.userLastName = this.user.attributes.last_name;

        this.$scope.userLanguage.selectedValue = this.$scope.languages.find(value =>
            value.code === this.user.attributes.language);

        this.$scope.userCountry.selectedValue = this.$scope.countries.find(value =>
            value.code === this.user.attributes.country);

        this.$scope.userState.selectedValue = this.$scope.states.find(value =>
            value.code === this.user.attributes.land);

    }

}

/**
     * @ngdoc directive
     * @name directives.ProfileDetailsDirective
     *
     * @description
     * edit form for user details directive
     */
class ProfileDetailsDirective {

    constructor() {

        this.template = require('./profile-details.html');
        this.restrict = 'EA';
        this.replace = false;
        this.scope = {};

        _controllerDependencies.push((
            $scope, $state, $timeout, $window,
            MyAccountCountriesService, UserRestService, Util,
            MyAccountStatesService, $rootScope,
        ) =>
            new ProfileDetailsController(
                $scope, $state, $timeout, $window,
                MyAccountCountriesService, UserRestService, Util,
                MyAccountStatesService, $rootScope,
            ));
        this.controller = _controllerDependencies;
        this.controllerAs = 'ProfileDetailsCtrl';

    }

}

_directiveDependencies.push(() => new ProfileDetailsDirective());


angular.module('directives')
    .directive('profileDetails', _directiveDependencies);




// WEBPACK FOOTER //
// ./scripts/directives/dashboard/my-account/profile/profile-details/profile-details.js